/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-imports */
import React, {useEffect, useState } from "react";

import {
  Card,
  CardBody,
  CardHeader,
} from "../../_metronic/_partials/controls";
// import { useMerchantUIContext } from "./MerchantUIContext";
import { WIXMerchantTable } from "./merchant-table/WIXMerchantTable";
import { WPMerchantTable } from "./merchant-table/WPMerchantTable";

import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {Avatar} from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import {toAbsoluteUrl} from "../../_metronic/_helpers";
import { ShopifyMerchantTable } from "./merchant-table/ShopifyMerchantTable";
import { BigcommerceMerchantTable } from "./merchant-table/BigcommerceMerchantTable";
import { PortalMerchantTable } from "./merchant-table/PortalMerchantTable";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: 'transparent',
    color: 'red'
  },
}));


function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

export default function MerchantCard() {

  const classes = useStyles();
  const [value, setValue] = useState(0);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const tab = params.get('tab');

  useEffect(() => {
    if(tab !== null) {
      setValue(parseInt(tab));
    }
  }, [tab])

  const history = useHistory();

  // const merchantUIContext = useMerchantUIContext();
  // const merchantUIProps = useMemo(() => {
  //   return {
  //     ids: merchantUIContext.ids,
  //     queryParams: merchantUIContext.queryParams,
  //     setQueryParams: merchantUIContext.setQueryParams,
  //     newMerchantButtonClick: merchantUIContext.newMerchantButtonClick,
  //   };
  // }, [merchantUIContext]);

  function handleChange(event, newValue) {
    setValue(newValue);
    history.push(`/merchants?tab=${newValue}`)
  }

  return (
    <Card>
      <CardHeader title='Merchants'>
      </CardHeader>{" "}  
      <CardBody>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          className={classes.root}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab icon={<Avatar alt="shopify" src={toAbsoluteUrl("/media/platforms/shopify.png")}/>} aria-label="Phone" /> 
          <Tab icon={<Avatar alt="wix" src={toAbsoluteUrl("/media/platforms/wix.png")}/>} aria-label="Phone" />
          <Tab icon={<Avatar alt="wordpress" src={toAbsoluteUrl("/media/platforms/wordpress.png")}/>} aria-label="Phone" />
          <Tab icon={<Avatar alt="bigcommerce" src={toAbsoluteUrl("/media/platforms/bigcommerce.png")}/>} aria-label="Phone" />
          <Tab icon={<Avatar alt="vendor_portal" src={toAbsoluteUrl("/media/platforms/vendorPortal.png")}/>} aria-label="Phone" />
        </Tabs>
        {value === 0 && <TabContainer><ShopifyMerchantTable tabValues={value}/></TabContainer>}
        {value === 1 && <TabContainer><WIXMerchantTable tabValues={value}/></TabContainer>}
        {value === 2 && <TabContainer><WPMerchantTable tabValues={value}/></TabContainer>}
        {value === 3 && <TabContainer><BigcommerceMerchantTable tabValues={value}/></TabContainer>}
        {value === 4 && <TabContainer><PortalMerchantTable tabValues={value}/></TabContainer>}
      </CardBody>
    </Card>
  );
}